<template>
	<div class="content_main">
		<div style="margin-top: 10px">
			<a-button type="primary" @click="Input">盘盈录入</a-button>
			<a-button type="primary" :disabled="selectedRowKeys2.length < 1" @click="loss">盘亏报废</a-button>
		</div>
		<div class="content_main_top">
			<a-select show-search allowClear placeholder="公司名称" class="margin_self" @change="handlecompany"
				v-model="company_id" @keyup.enter.native="query" style="width: 120px">
				<a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
					{{ item.title }}
				</a-select-option>
			</a-select>
			<a-tree-select allowClear :treeData="deptTree2" placeholder="部门名称" class="margin_self"
				@keyup.enter.native="query" v-model="dept_id" :disabled="!company_id" style="width: 170px"
				@change="handledept" treeDefaultExpandAll>
			</a-tree-select>
			<a-input v-model="category_name" allowClear class="a_input_self margin_self" placeholder="品类名称"
				@keyup.enter.native="query" />
			<a-select show-search allowClear placeholder="资产类别" class="margin_self" v-model="asset_type"
				style="width: 120px" @keyup.enter.native="query">
				<a-select-option :value="item.value" v-for="(item, index) in goodsType" :key="index">
					{{ item.label }}
				</a-select-option>
			</a-select>
			<a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="物品编号"
				@keyup.enter.native="query" />
			<a-input v-model="name" allowClear class="a_input_self margin_self" placeholder="物品名称"
				@keyup.enter.native="query" />
			
			<a-select show-search allowClear placeholder="物品状态" class="margin_self" v-model="state" style="width: 120px"
				@keyup.enter.native="query">
				<a-select-option :value="index" v-for="(item, index) in statusMap" :key="index">
					{{ item }}
				</a-select-option>
			</a-select>
			<a-input v-model="charger" allowClear class="margin_self" placeholder="责任人" style="width: 100px"
				@keyup.enter.native="query" />
			<a-input v-model="keeper" allowClear class="margin_self" placeholder="保管人" style="width: 100px"
						@keyup.enter.native="query" />
			<a-select show-search allowClear placeholder="标签打印" class="margin_self" v-model="is_labelled"
				style="width: 120px" @keyup.enter.native="query">
				<a-select-option :value="index" v-for="(item, index) in labelledMap" :key="index">
					{{ item }}
				</a-select-option>
			</a-select>
			<a-select show-search allowClear placeholder="图片上传" class="margin_self" v-model="has_pic"
				style="width: 120px" @keyup.enter.native="query">
				<a-select-option :value="index" v-for="(item, index) in imgMap" :key="index">
					{{ item }}
				</a-select-option>
			</a-select>
			
			<!-- <a-select show-search allowClear v-model="dept_id" :disabled="!company_id" placeholder="部门名称" class="margin_self" @keyup.enter.native="query"
			 style="width: 170px" @change="handledept">
				<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select> -->
			
			<a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 220px" allowClear :value="dates"
				@change="onChange" :placeholder="['采购开始', '采购结束']" @keyup.enter.native="query" />
			<a-button type="primary" @click="query"> 查询 </a-button>
			<a-button type="primary" ghost @click="result"> 重置 </a-button>
		</div>
		<div class="content_main_center" id="content_main_center_scroll" style="height: calc(100% - 142px)">
			<a-table :columns="columns" :data-source="data" rowKey="id"
				:row-selection="{ selectedRowKeys: selectedRowKeys2, onChange: onSelectChange, type:'radio' }" bordered
				:pagination="false" :scroll="{ x: 1500, y: scroll_y }">
				<span slot="index" slot-scope="text, record, index">
			 	{{ (current - 1) * pageSize + index + 1 }}
				</span>
				<span slot="asset_type" slot-scope="text">
					{{ text ? goodsTypeObj[text] : '' }}
				</span>
				<span slot="state" slot-scope="text">
					<template>
						<a-tag :color="colors[text]">
							{{ text ? statusMap[text] : '' }}
						</a-tag>
					</template>
				</span>
				<span slot="is_inspected" slot-scope="text">
					{{ instrumentMap[text] }}
				</span>
				<span slot="is_labelled" slot-scope="text" :style="{ color: text == 1 ? '#1890ff' : 'red' }">
					{{ text == 1 ? '已打印标签' : '未打印标签' }}
				</span>
				<span slot="img" slot-scope="text, record" :style="{ color: record.pic_path ? 'green' : 'red' }">
					{{ record.pic_path ? '已上传图片' : '未上传图片' }}
				</span>
				<span slot="action" slot-scope="text, record">
					<a @click="details(record)">详情</a>
				</span>
			</a-table>
		</div>
		<div class="content_main_bot">
			<a-pagination v-model="current" show-size-changer :page-size.sync="pageSize" :total="total"
				@showSizeChange="showSizeChange" :pageSizeOptions="['10', '20', '30', '50']"
				@change="onShowSizeChange" />
		</div>
		<a-modal v-model="changevisible" title="批量修改金额">
			<template slot="footer">
				<a-button key="back" @click="moneyCancel"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="moneyOk"> 保存 </a-button>
			</template>
			<a-table :data-source="selectedRow" bordered :pagination="false">
				<a-table-column key="name" title="物品名称" data-index="name" />
				<a-table-column key="model" title="规格型号" data-index="model" />
				<a-table-column key="asset_sn" title="物品编号" data-index="asset_sn" />
				<a-table-column key="value" title="当前估值" data-index="value">
					<template slot-scope="text, record">
						<a-input v-model="record.value" />
					</template>
				</a-table-column>
			</a-table>
		</a-modal>
		<a-modal title="固定资产-详情" :visible="detailsvisible" @cancel="detailsCancel" width="880px">
			<template slot="footer">
				<a-button key="back" @click="detailsOk"> 取消 </a-button>
			</template>
			<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol">
				<a-form-model-item label="资产类别" class="form_item">
					<span>{{ detailsrow.asset_type ? goodsTypeObj[detailsrow.asset_type] : '' }}</span>
				</a-form-model-item>
				<a-form-model-item label="品类名称" class="form_item">
					<span>{{  detailsrow.category_name }}</span>
				</a-form-model-item>
				<div v-if="detailsrow.asset_type === 53 ">
					<a-form-model-item label="仪器一级分类" class="form_item">
						<span>{{ detailsrow.device_type_name }}</span>
					</a-form-model-item>
					<a-form-model-item label="仪器二级分类" class="form_item">
						<span>{{  detailsrow.dict_key_name }}</span>
					</a-form-model-item>
				</div>
				<a-form-model-item label="物品编号" class="form_item">
					<span>{{ detailsrow.asset_sn }}</span>
				</a-form-model-item>
				<a-form-model-item label="物品名称" class="form_item">
					<span>{{ detailsrow.name }}</span>
				</a-form-model-item>
				<a-form-model-item label="物品单位" class="form_item">
					<span>{{ detailsrow.unit }}</span>
				</a-form-model-item>
				<a-form-model-item label="物品状态" class="form_item">
					<span>{{ detailsrow.state ? statusMap[detailsrow.state] : '' }}</span>
				</a-form-model-item>
				<a-form-model-item label="规格型号" class="form_item">
					<span>{{ detailsrow.model }}</span>
				</a-form-model-item>
				<a-form-model-item label="采购时间" class="form_item">
					<span>{{ detailsrow.purchase_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="采购价格" class="form_item">
					<span>{{ detailsrow.purchase_price }}</span>
				</a-form-model-item>
				<a-form-model-item label="负责部门" class="form_item">
					<span>{{ detailsrow.dept_id ? deptMap[detailsrow.dept_id].title : '' }}</span>
				</a-form-model-item>
				<a-form-model-item label="当前估值" class="form_item">
					<span>{{ detailsrow.value }}</span>
				</a-form-model-item>
				<a-form-model-item label="责 任 人 " class="form_item">
					<span>{{ detailsrow.charger }}</span>
				</a-form-model-item>
				<a-form-model-item label="入 库 人 " class="form_item">
					<span>{{ detailsrow.operator }}</span>
				</a-form-model-item>
				<a-form-model-item label="保 管 人 " class="form_item">
					<span>{{ detailsrow.keeper }}</span>
				</a-form-model-item>
				<a-form-model-item label="到货日期" class="form_item">
					<span>{{ detailsrow.arrive_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="存放位置" class="form_item">
					<span>{{ detailsrow.storage_loc }}</span>
				</a-form-model-item>
				<a-form-model-item label="作业条件" class="form_item">
					<span>{{ detailsrow.storage_cond }}</span>
				</a-form-model-item>
				<a-form-model-item label="供 应 商 " class="form_item">
					<span>{{ detailsrow.dealer }}</span>
				</a-form-model-item>
				<a-form-model-item label="生产厂家" class="form_item">
					<span>{{ detailsrow.manufacturer }}</span>
				</a-form-model-item>
				<a-form-model-item label="出厂编号" class="form_item">
					<span>{{ detailsrow.factory_sn }}</span>
				</a-form-model-item>
				<a-form-model-item label="是否检定" class="form_item">
					<span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
				</a-form-model-item>
				<a-form-model-item label="检定周期" class="form_item">
					<span>{{ detailsrow.inspect_cycle }}</span>
				</a-form-model-item>
				<a-form-model-item label="检定日期" class="form_item">
					<span>{{ detailsrow.inspect_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="仪器精度" class="form_item">
					<span>{{ detailsrow.precisions }}</span>
				</a-form-model-item>
				<a-form-model-item label="检定结果" class="form_item">
					<span>{{ detailsrow.inspect_result }}</span>
				</a-form-model-item>
				<a-form-model-item label="准用说明" class="form_item">
					<span>{{ detailsrow.permit }}</span>
				</a-form-model-item>
				<a-form-model-item label="录 入 人 " class="form_item">
					<span>{{ detailsrow.create_by }}</span>
				</a-form-model-item>
				<a-form-model-item label="录入时间" class="form_item">
					<span>{{ detailsrow.create_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="维 护 人 " class="form_item">
					<span>{{ detailsrow.update_by }}</span>
				</a-form-model-item>
				<a-form-model-item label="维护时间" class="form_item">
					<span>{{ detailsrow.update_time }}</span>
				</a-form-model-item>
				
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="备注信息">
					         <span>{{ detailsrow.notes }}</span>
				        </a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品图片">
							<div class="view_path_img" v-for="(item, index) in detailsrow.pic_path_list" :key="index"
								style="display: flex; justify-content: space-between">
								<div class="view_path_img_margin"></div>
								<div class="view_path_img_center">
									<img :src="item" @click="show_img(index, detailsrow.pic_path_list)" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="附件信息">
							<div class="view_path" @click="previewFile(item)"
								v-for="(item, index) in detailsrow.att_paths" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="证书信息">
							<div class="view_path" @click="previewFile(item)"
								v-for="(item, index) in detailsrow.cert_paths" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<!-- <a-modal title="物品信息维护" :visible="editvisible" @ok="editOk" @cancel="editCancel" width="880px"
			:maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="editCancel"> 取消 </a-button>
				<a-button type="primary" @click="editOk"> 保存 </a-button>
			</template>
			<a-form-model ref="ruleForm" :rules="rules" :model="detailsrow" :labelCol="labelCol"
				:wrapperCol="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="资产类别">
							<span>{{detailsrow.asset_type?goodsTypeObj[detailsrow.asset_type]:''}}</span>
							<a-select allowClear v-model="assets" placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in assettype" :value="item.dictCode">
									{{ item.dictLabel }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品编号">
							<span>{{ detailsrow.asset_sn }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品名称">
							<span>{{ detailsrow.name }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品单位">
							<a-input allowClear v-model="detailsrow.unit" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品状态">
							<a-select allowClear v-model="states" placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in statusMap6" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="规格型号" ref="model" prop="model">
							<span>{{detailsrow.model}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购时间">
							<span>{{detailsrow.purchase_time}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购价格">
							<span>{{detailsrow.purchase_price}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="责任部门" ref="dept_id" prop="dept_id">
							<span>{{detailsrow.dept_name}}</span>
							<a-tree-select :treeData="deptTree" placeholder="负责部门" v-model="detailsrow.dept_id"
								treeDefaultExpandAll>
							</a-tree-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="当前估值">
							<a-input allowClear type="number" v-model="detailsrow.value" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="责 任 人 " ref="charger">
							<a-input allowClear v-model="detailsrow.charger" placeholder="请输入" />
							<span>{{detailsrow.charger}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="入 库 人 ">
							<span>{{detailsrow.operator}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="保 管 人 ">
							<a-input allowClear v-model="detailsrow.keeper" placeholder="请输入" />
							<span>{{detailsrow.keeper}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="到货日期">
							<span>{{detailsrow.arrive_time}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="存放位置">
							<a-input allowClear v-model="detailsrow.storage_loc" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="作业条件">
							<a-input allowClear v-model="detailsrow.storage_cond" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="供 应 商 ">
							<a-input allowClear v-model="detailsrow.dealer" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="生产厂家">
							<a-input allowClear v-model="detailsrow.manufacturer" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="出厂编号">
							<a-input allowClear v-model="detailsrow.factory_sn" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="是否检定">
							<a-select v-model="isinstrument" placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定周期">
							<a-input allowClear v-model="detailsrow.inspect_cycle" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定日期">
							<a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
								v-model="detailsrow.inspect_time" placeholder="请输入" style="width: 312px" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="仪器精度">
							<a-input allowClear v-model="detailsrow.precisions" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定结果">
							<a-input allowClear v-model="detailsrow.inspect_result" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="准用说明">
							<a-input allowClear v-model="detailsrow.permit" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注信息">
							<a-input allowClear v-model="detailsrow.notes" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="录 入 人 ">
							<span>{{detailsrow.create_by}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="录入时间">
							<span>{{detailsrow.create_time}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="维 护 人 ">
							<span>{{detailsrow.update_by}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="维护时间">
							<span>{{detailsrow.update_time}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="附件信息">
							<a-upload action="https://coa.anliantest.com/oaProxyApi/proxyPython/file/upload"
								:headers="headers" name="file" :defaultFileList="defaultFileList"
								v-if="detailsrow.asset_sn && detailsrow.dept_id && is_uplaod2" :remove="removeFile"
								@preview="previewFile"
								:data="{ type: 'asset', file_name: file_name, asset_sn: upload.asset_sn, dept_id: upload.dept_id }"
								method="post" :beforeUpload="beforeUpload" @change="handleChange">
								<a-button>
									<a-icon type="upload" /> 上传文件
								</a-button>
							</a-upload>
							<el-row>
								<div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
							</el-row>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品图片">
							<div class="view_path_img" v-for="(item, index) in detailsrow.pic_path_list" :key="index"
								style="display: flex; justify-content: space-between">
								<div class="view_path_img_margin"></div>
								<div class="view_path_img_center">
									<img :src="item" @click="show_img(index, detailsrow.pic_path_list)" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12"> </a-col>
					<a-col :span="12">
						<a-form-model-item label="证书信息">
							<a-upload action="https://coa.anliantest.com/oaProxyApi/proxyPython/file/upload"
								:headers="headers" name="file" :defaultFileList="defaultFileList2"
								v-if="detailsrow.asset_sn && detailsrow.dept_id && is_uplaod3" :remove="removeFile2"
								@preview="previewFile"
								:data="{ type: 'asset', file_name: file_name2, asset_sn: upload2.asset_sn, dept_id: upload2.dept_id }"
								method="post" :beforeUpload="beforeUpload2" @change="handleChange2">
								<a-button>
									<a-icon type="upload" /> 上传文件
								</a-button>
							</a-upload>
							<el-row>
								<div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
							</el-row>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal> -->
		<a-modal title="详情" :visible="Warehousingvisible" @cancel="WarehousingCancel" width="880px">
			<template slot="footer">
				<a-button type="primary" @click="WarehousingOk"> 确定 </a-button>
			</template>
			<a-form-model :model="Warehousingrow" style="height: 500px">
				<a-form-model-item label="资产类别" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.asset_type ? operTypeMap[Warehousingrow.asset_type].text : '' }}</span>
				</a-form-model-item>
				<a-form-model-item label="物品状态" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.state ? statusMap[Warehousingrow.state] : '' }}</span>
				</a-form-model-item>
				<a-form-model-item label="物品名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.asset }}</span>
				</a-form-model-item>
				<a-form-model-item label="采购时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.purchase_time }}</span>
				</a-form-model-item>
				<!-- <a-form-model-item label="是否仪器" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.is_instrument == null ? '' : instrumentMap[Warehousingrow.is_instrument] }}</span>
				</a-form-model-item> -->
				<a-form-model-item label="采购价格" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.purchase_price }}</span>
				</a-form-model-item>
				<a-form-model-item label="物品编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.asset_sn }}</span>
				</a-form-model-item>
				<a-form-model-item label="供 应 商 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.dealer }}</span>
				</a-form-model-item>
				<a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.model }}</span>
				</a-form-model-item>
				<a-form-model-item label="负责部门" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.dept_id ? deptMap[Warehousingrow.dept_id].title : '' }}</span>
				</a-form-model-item>
				<a-form-model-item label="责 任 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.charger }}</span>
				</a-form-model-item>
				<a-form-model-item label="物品数量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.amount }}</span>
				</a-form-model-item>
				<a-form-model-item label="入 库 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.operator }}</span>
				</a-form-model-item>
				<a-form-model-item label="准用说明" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.permit }}</span>
				</a-form-model-item>
				<a-form-model-item label="保 管 人 " :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.keeper }}</span>
				</a-form-model-item>
				<a-form-model-item label="最后检定时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.inspect_time }}</span>
				</a-form-model-item>
				<a-form-model-item label="检定结果" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.inspect_result }}</span>
				</a-form-model-item>
				<a-form-model-item label="精度" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
					<span>{{ Warehousingrow.precisions }}</span>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<a-modal title="固定资产-盘盈录入" v-model="visible2" @ok="preservation2" @cancel="handleCancel2" width="880px"
			:maskClosable="false">
			<template slot="footer">
				<a-button key="back" @click="handleCancel2"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="preservation2"> 保存 </a-button>
			</template>
			<a-form :form="form2" :labelCol="labelCol" :wrapperCol="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-item label="资产类别">
							<a-select 
							allowClear
							v-decorator="['asset_type', { rules: [{ required: true, message: '请选择资产类别!' }] }]"
							placeholder="请选择"
							@change="changeAsset($event)">
								<a-select-option :key="index" v-for="(item, index) in goodsType" :value="item.value">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="品类名称">
							<a-select allowClear show-search :filter-option="filterOption" @change="changeCategoryName1"
								v-decorator="['category_id', { rules: [{ required: true, message: '请选择品类名称!' }] }]"
								placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in nameList" :value="item.id">
									{{ item.categoryName }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
                </a-row>
				  <a-row v-if="classify">
					<a-col :span="12">
						<a-form-item label="仪器一级分类">
						<a-select
							allowClear
							:filter-option="filterOption"
							v-decorator="['deviceType', { rules: [{ required: true, message: '请选择仪器一级分类!' }] }]"
							placeholder="请选择"
							@change="getLabList"
						>
							<a-select-option :key="index" v-for="(item, index) in dictList" :value="item.dictValue">
							{{ item.remark }}
							</a-select-option>
						</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="仪器二级分类">
						<a-select
							allowClear
							:filter-option="filterOption"
							v-decorator="['dictkey', { rules: [{ required: true, message: '请选择仪器二级分类!' }] }]"
							placeholder="请选择"
							:disabled="!deviceId"
						>
							<a-select-option :key="index" v-for="(item, index) in labList" :value="item.dictValue">
							{{ item.dictLabel }}
							</a-select-option>
						</a-select>
						</a-form-item>
					</a-col>
					</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="物品编号">
							<a-input allowClear
								v-decorator="['asset_sn', { rules: [{ required: true, message: '请填写物品编号!' }] }]"
								placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="物品名称">
							<a-input allowClear
								v-decorator="['name', { rules: [{ required: true, message: '请填写物品名称!' }] }]"
								placeholder="请输入" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="物品单位">
							<a-input allowClear
								v-decorator="['unit', { rules: [{ required: true, message: '请输入单位!' }] }]"
								placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="物品状态">
							<a-select allowClear
								v-decorator="['state', { rules: [{ required: true, message: '请选择状态!' }] }]"
								placeholder="请选择" @change="statechange">
								<a-select-option :key="index" v-for="(item, index) in statusMap6" :value="index" :disabled=" index == 6 || index== 9">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="规格型号">
							<a-input allowClear
								v-decorator="['model', { rules: [{ required: true, message: '请填写规格型号!' }] }]"
								placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="采购时间">
							<a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
								v-decorator="['purchase_time', { rules: [{ required: true, message: '请选择采购时间!' }] }]"
								placeholder="请输入" style="width: 312px" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="采购价格">
							<a-input @blur="changevalue" type="number" allowClear
								v-decorator="['purchase_price', { rules: [{ required: true, message: '请输入采购价格!' }] }]"
								placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="责任部门">
							<a-tree-select :treeData="deptTree" placeholder="请输入"
								v-decorator="['dept_id', { rules: [{ required: true, message: '请选择责任部门!' }] }]"
								treeDefaultExpandAll @change="leaderid($event)">
							</a-tree-select>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="当前估值">
							<a-input allowClear type="number" v-decorator="['value']" placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="责 任 人 ">
							<a-input allowClear
								v-decorator="['charger', { rules: [{ required: true, message: '请输入责任人!' }] }]"
								placeholder="请输入" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="入 库 人 ">
							<a-input allowClear v-decorator="['operator']" placeholder="请输入" disabled/>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="保 管 人 ">
							<a-select show-search allowClear placeholder="请输入" class="margin_self"
								v-decorator="['keeper', { rules: [{ required: true, message: '请输入保管人!' }] }]">
								<a-select-option :value="item.userName" v-for="(item, index) in plainOptions"
									:key="index">
									{{ item.userName }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="到货日期">
							<a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
								v-decorator="['arrive_time']" placeholder="请输入" style="width: 312px" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="存放位置">
							<a-input allowClear v-decorator="['storage_loc']" placeholder="请输入" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="作业条件">
							<a-input allowClear v-decorator="['storage_cond']" placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="供 应 商 ">
							<a-input allowClear v-decorator="['dealer']" placeholder="请输入" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="生产厂家">
							<a-input allowClear v-decorator="['manufacturer']" placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="出厂编号">
							<a-input allowClear v-decorator="['factory_sn']" placeholder="请输入" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="是否已检定">
							<a-select allowClear v-decorator="['is_inspected']" placeholder="请选择">
								<a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="检定周期">
							<a-input allowClear v-decorator="['inspect_cycle']" placeholder="请输入" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="检定日期">
							<a-date-picker valueFormat="YYYY-MM-DD" :disabled-date="disabledDate" allowClear
								v-decorator="['inspect_time']" placeholder="请输入" style="width: 312px" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="仪器精度">
							<a-input allowClear v-decorator="['precisions']" placeholder="请输入" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="检定结果">
							<a-input allowClear v-decorator="['inspect_result']" placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="准用说明">
							<a-input allowClear v-decorator="['permit']" placeholder="请输入" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-item label="备注信息">
							<a-input allowClear v-decorator="['notes']" placeholder="请输入" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="上传附件">
							<a-upload
								v-if="form2.getFieldValue('asset_sn') && form2.getFieldValue('dept_id') && is_uplaod"
								:action="url" :headers="headers" name="file" :remove="removeFile"
								:default-file-list="defaultFileList" @preview="previewFile" :data="{
								  type: 'asset',
								  fileName: file_name,
								  assetSn: form2.getFieldValue('asset_sn'),
								  deptId: form2.getFieldValue('dept_id'),
								}" method="post" :beforeUpload="beforeUpload" @change="handleChange">
								<a-button>
									<a-icon type="upload" /> 上传文件
								</a-button>
							</a-upload>
							<el-row>
								<div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
							</el-row>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item label="上传证书">
							<a-upload :action="url" :headers="headers" name="file"
								:defaultFileList="defaultFileList2"
								v-if="form2.getFieldValue('asset_sn') && form2.getFieldValue('dept_id') && is_uplaod4"
								:remove="removeFile2" @preview="previewFile" :data="{ type: 'asset', fileName: file_name2, assetSn: form2.getFieldValue('asset_sn'),
                  deptId: form2.getFieldValue('dept_id'), }" method="post" :beforeUpload="beforeUpload2"
								@change="handleChange2">
								<a-button>
									<a-icon type="upload" /> 上传文件
								</a-button>
							</a-upload>
							<el-row>
								<div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
							</el-row>
						</a-form-item>
					</a-col>
				</a-row>
			</a-form>
		</a-modal>
		<a-modal title="固定资产-盘亏报废" :visible="profitvisible" @cancel="profitvisible = false" :confirm-loading="confirmLoading"
			width="70%" :maskClosable="false">
			<template slot="footer">
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkAdd"> 提交 </a-button>
				<a-button key="back" @click="profitvisible = false"> 取消 </a-button>
			</template>
			<a-form-model :model="form" :rules="rules" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
						<ccChange :data="ccC" :money="moneY" @targetKeys="getdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="盘亏报废原因" prop="remark" :rules="{
		        required: true,
		        message: '请输入盘亏报废原因',
		        trigger: 'change',
		      }" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<a-input v-model="form.remark" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-table :data-source="form.losslist" bordered :pagination="false">
						<a-table-column key="asset_type" title="资产类别" ellipsis="true" data-index="asset_type">
							<template scope="text,record">
								{{ text ? goodsTypeObj[text] : '' }}
							</template>
						</a-table-column>
						<a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
						<a-table-column key="asset_sn" title="物品编号" ellipsis="true" data-index="asset_sn" />
						<a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
						<a-table-column key="state" title="物品状态" ellipsis="true" data-index="state">
							<template scope="text,record">
								<a-tag :color="colors[text]">
									{{ text ? statusMap[text] : '' }}
								</a-tag>
							</template>
						</a-table-column>
						<a-table-column key="purchase_time" title="采购时间" ellipsis="true" data-index="purchase_time" />
						<a-table-column key="purchase_price" title="采购价格" ellipsis="true" data-index="purchase_price" />
						<a-table-column key="value" title="当前估值" ellipsis="true" data-index="value" />
						<a-table-column key="charger" title="责任人" ellipsis="true" data-index="charger" />
						<a-table-column key="dept_id" title="责任部门" ellipsis="true" data-index="dept_id">
							<template scope="text,record">
								{{ text ? deptMap[text].title : '' }}
							</template>
						</a-table-column>
					</a-table>
				</a-row>
			</a-form-model>
		</a-modal>
		<preview ref="preview" />
	</div>
</template>
<script>
import { getDictDataList } from '@/api/system'
import { limitCompany } from '@/utils/limitCompany'
import { enableParent} from '@/api/purchase'
import { categoryNameList } from '@/api/question'
	import {

		get_list,
		get_checkin,
		purchase,
		checkin,
		dict,
		dept_get,
		batch_save_value,
		update,
		// get_dept_tree,
		remove,
		asset_remove,
		get_list2_xlsx,
		daily_list,
		scrapped_apply,
		assetInfo
	} from '@/api/assetmenag'
	import debounce from 'lodash/debounce'
	import {
		getDeptListEnable,
		getDeptListEnable2
	} from '@/api/system'
	import {
		checkPermission
	} from '@/utils/permissions'
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	import storage from 'store'
	import {
		get_users2,
		get_dict
	} from '@/utils/unit_axios'
	import preview from '@/components/module/prview'
	import ccChange from '@/components/module/ccChange'
	const deptMap = {}
	const columns = [{
			title: '序号',
			dataIndex: 'index',
			key: 'index',
			scopedSlots: {
				customRender: 'index',
			},
			width: 70,
			ellipsis: true,
		},
		 {
			title: '所属公司',
			dataIndex: 'company_name',
			key: 'company_name',
			width: 150,
			ellipsis: true,
		},
		{
			title: '所属部门',
			dataIndex: 'dept_name',
			key: 'dept_name',
			width: 150,
			ellipsis: true,
		},
		{
			title: '资产类别',
			dataIndex: 'asset_type',
			key: 'asset_type',
			scopedSlots: {
				customRender: 'asset_type',
			},
			width: 150,
			ellipsis: true,
		},
		{
			title: '品类名称',
			dataIndex: 'category_name',
			key: 'category_name',
			width: 150,
			ellipsis: true,
		},
		{
			title: '物品编号',
			dataIndex: 'asset_sn',
			key: 'asset_sn',
			width: 150,
			ellipsis: true,
		},
		{
			title: '物品名称',
			dataIndex: 'name',
			key: 'name',
			width: 150,
			ellipsis: true,
		},
		{
			title: '规格型号',
			dataIndex: 'model',
			key: 'model',
			width: 300,
			ellipsis: true,
		},
		{
			title: '物品单位',
			dataIndex: 'unit',
			key: 'unit',
			width: 150,
			ellipsis: true,
		},
		{
			title: '物品状态',
			dataIndex: 'state',
			key: 'state',
			scopedSlots: {
				customRender: 'state',
			},
			width: 150,
			ellipsis: true,
		},
		{
			title: '是否检定',
			dataIndex: 'is_inspected',
			key: 'is_inspected',
			scopedSlots: {
				customRender: 'is_inspected',
			},
			width: 150,
			ellipsis: true,
		},
		{
			title: '准用说明',
			dataIndex: 'permit',
			key: 'permit',
			width: 150,
			ellipsis: true,
		},
		{
			title: '责任人',
			dataIndex: 'charger',
			key: 'charger',
			width: 150,
			ellipsis: true,
		},
		{
			title: '供应商',
			dataIndex: 'dealer',
			key: 'dealer',
			width: 150,
			ellipsis: true,
		},
		{
			title: '当前估值',
			dataIndex: 'value',
			key: 'value',
			width: 150,
			ellipsis: true,
		},
		{
			title: '采购单价',
			dataIndex: 'purchase_price',
			key: 'purchase_price',
			width: 150,
			ellipsis: true,
		},
		{
			title: '采购时间',
			dataIndex: 'purchase_time',
			key: 'purchase_time',
			width: 150,
			ellipsis: true,
		},
		{
			title: '备注',
			dataIndex: 'notes',
			key: 'notes',
			width: 150,
			ellipsis: true,
		},
		{
			title: '录入人',
			dataIndex: 'create_by',
			key: 'create_by',
			width: 150,
			ellipsis: true,
		},
		{
			title: '录入时间',
			dataIndex: 'create_time',
			key: 'create_time',
			width: 200,
			ellipsis: true,
		},
		{
			title: '维护人',
			dataIndex: 'update_by',
			key: 'update_by',
			width: 150,
			ellipsis: true,
		},
		{
			title: '维护时间',
			dataIndex: 'update_time',
			key: 'update_time',
			width: 200,
			ellipsis: true,
		},
		{
			title: '标签打印',
			dataIndex: 'is_labelled',
			key: 'is_labelled',
			width: 150,
			scopedSlots: {
				customRender: 'is_labelled',
			},
			ellipsis: true,
		},
		{
			title: '物品图片',
			dataIndex: 'img',
			width: 150,
			key: 'img',
			scopedSlots: {
				customRender: 'img',
			},
		},
		{
			title: '操作',
			key: 'action',
			scopedSlots: {
				customRender: 'action',
			},
			fixed: 'right',
			width: 150,
		},
	]
	const columns2 = [{
			title: '资产类别',
			dataIndex: 'asset_type',
			key: 'asset_type',
			scopedSlots: {
				customRender: 'asset_type',
			},
		},
		{
			title: '物品名称',
			dataIndex: 'asset',
			key: 'asset',
		},
		{
			title: '物品编号',
			dataIndex: 'asset_sn',
			key: 'asset_sn',
		},
		{
			title: '规格规格',
			dataIndex: 'model',
			key: 'model',
		},
		{
			title: '物品数量',
			dataIndex: 'amount',
			key: 'amount',
		},
		{
			title: '物品状态',
			dataIndex: 'state',
			key: 'state',
			scopedSlots: {
				customRender: 'state',
			},
		},
		{
			title: '准用说明',
			dataIndex: 'permit',
			key: 'permit',
		},
		{
			title: '采购时间',
			dataIndex: 'purchase_time',
			key: 'purchase_time',
		},
		{
			title: '采购价格',
			dataIndex: 'purchase_price',
			key: 'purchase_price',
		},
		{
			title: '供应商',
			dataIndex: 'dealer',
			key: 'dealer',
		},
		{
			title: '责任人',
			dataIndex: 'charger',
			key: 'charger',
		},
		{
			title: '责任部门',
			dataIndex: 'dept_id',
			key: 'dept_id',
			scopedSlots: {
				customRender: 'dept_id',
			},
		},
		{
			title: '上次检定结果',
			dataIndex: 'inspect_result',
			key: 'inspect_result',
		},
		{
			title: '上次检定时间',
			dataIndex: 'inspect_time',
			key: 'inspect_time',
		},
		{
			title: '操作',
			key: 'action',
			scopedSlots: {
				customRender: 'action',
			},
		},
	]
	const columns3 = [{
			title: '领用单号',
			dataIndex: 'amo',
			key: 'amo',
		},
		{
			title: '部门',
			dataIndex: 'dept_id',
			key: 'dept_id',
			scopedSlots: {
				customRender: 'dept_id',
			},
		},
		{
			title: '领用人',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: '产品名',
			dataIndex: 'asset',
			key: 'asset',
		},
		{
			title: '产品编号',
			dataIndex: 'asset_sn',
			key: 'asset_sn',
		},
		{
			title: '数量',
			dataIndex: 'amount',
			key: 'amount',
		},
		{
			title: '领用时间',
			dataIndex: 'amo',
			key: 'amo',
		},
	]
	const columns4 = [{
			title: '物品名称',
			dataIndex: 'name',
			key: 'name',
			ellipsis: true,
		},
		{
			title: '规格型号',
			dataIndex: 'model',
			key: 'model',
			ellipsis: true,
		},
		{
			title: '物品编号',
			dataIndex: 'asset_sn',
			key: 'asset_sn',
			ellipsis: true,
		},
		{
			title: '当前估值',
			dataIndex: 'purchase_price',
			key: 'purchase_price',
			scopedSlots: {
				customRender: 'purchase_price',
			},
			width: 150,
			ellipsis: true,
		},
	]
	export default {
		data() {
			return {
				dictList: [],
                labList: [],
				classify: false,
				deviceId: false,
				nameList: [],
				category_name: '',
				keeper: '',
				url: process.env.VUE_APP_API_BASE_URL + "/file/file/upload_asset",
				categoryName: '',
				file_name: '',
				file_name2: '',
				statusMap: '',
				plainOptions: [],
				selectedRowKeys2: [],
				profitvisible: false,
				isRouterAlive: false,
				is_uplaod: false,
				is_uplaod2: false,
				is_uplaod3: false,
				is_uplaod4: false,
				fileList: [],
				removeList: [],
				defaultFileList: [],
				fileList2: [],
				removeList2: [],
				defaultFileList2: [],
				scroll_y: 150,
				deptMap,
				operTypeMap: {},
				changevisible: false,
				company_id: undefined,
				dept_id: undefined,
				data: [],
				companylist: [],
				deptlist: [],
				data2: [],
				data3: [],
				headers: {},
				deptTree: [],
				deptTree2: [],
				assettype: [],
				columns,
				columns2,
				columns3,
				columns4,
				moneY: '',
				upload: {
					asset_sn: '',
					dept_id: '',
				},
				upload2: {
					asset_sn: '',
					dept_id: '',
				},
				visible: false,
				visibleClaim: false,
				visibleexamine: false,
				editvisible: false,
				loading: false,
				Warehousingvisible: false,
				selectedRowKeys: [],
				selectedRow: [],
				name: '',
				asset_sn: '',
				state: undefined,
				asset_type: undefined,
				is_labelled: undefined,
				has_pic: undefined,
				start_date: '',
				num: 1,
				end_date: '',
				name2: '',
				charger: '',
				asset_sn2: '',
				state2: '',
				purchase_time2: '',
				pageSize: 10,
				current: 1,
				total: 0,
				pageSize2: 10,
				current2: 1,
				total2: 0,
				pageSize3: 10,
				current3: 1,
				total3: 0,
				detailsrow: {},
				Warehousingrow: {},
				dates: [],
				visible2: false,
				detailsvisible: false,
				form: {},
				ccC: 'scrapped',
				form2: this.$form.createForm(this),
				labelCol: {
					span: 6,
				},
				wrapperCol: {
					span: 18,
				},
				rules: {
					dept_id: [{
						required: true,
						message: '请选择责任部门！',
						trigger: 'blur',
					}, ],
					charger: [{
						required: true,
						message: '请输入责任人！',
						trigger: 'blur',
					}, ],
				},
			}
		},
		components: {
			preview,
			ccChange
		},
		computed: {
			hasSelected() {
				return this.selectedRowKeys.length > 0
			},
			assets: {
				get() {
					return this.detailsrow.asset_type ? this.operTypeMap[this.detailsrow.asset_type].text : undefined
				},
				set(value) {
					this.detailsrow.asset_type = value
				},
			},
			states: {
				get() {
					return this.detailsrow.state ? this.statusMap[this.detailsrow.state] : undefined
				},
				set(value) {
					this.detailsrow.state = value
				},
			},
			isinstrument: {
				get() {
					return this.detailsrow.is_inspected ? this.instrumentMap[this.detailsrow.is_inspected] : undefined
				},
				set(value) {
					this.detailsrow.is_inspected = value
				},
			},
		},
		filters: {
			operTypeFilter(type) {
				return operTypeMap[type].title
			},
			deptFilter(type) {
				return deptMap[type].title
			},
		},
		beforeCreate(){
		

		},
		created() {
			limitCompany().then(res=>{
				res.forEach(item => {
					if(item.deptId){
					this.companylist.push(item)
					}
				})
				this.companylist.forEach(item => {
					if(item.deptId == this.$store.state.user.info.companyId) {
						this.deptTree = item.children
						item.children.forEach(item2 => {
							this.deptMap[item2.deptId] = item2
						})
						console.log(this.deptMap, 'this.deptMap=================')
						
					}
				})

			})
			get_dict('goodStatus', (res) => {
				for (let i in res) {
					if (res[i] == '退货') {
						delete res[i]
					}
				}
				this.statusMap = res
			})
			dict({
				pageNum: 1,
				pageSize: 10,
				dictType: 'assets_type',
			}).then((res) => {
				this.assettype = res.rows
				this.assettype.map((d) => {
					this.operTypeMap[d.dictCode] = {
						text: d.dictLabel,
					}
				})
			})

			// getDeptListEnable2().then((res) => {
			// 	const data = res.rows
			// 	if (data.length > 0) {
			// 		const min = Math.min(...data.map((m) => m.parentId))
			// 		this.buildtree2(data, this.deptTree, min)
			// 		this.deptTree.map((d) => {
			// 			if (d.hasOwnProperty('children')) {
			// 				d.children.map((b) => {
			// 					deptMap[b.key] = {
			// 						text: b.title,
			// 					}
			// 					deptMap[d.key] = {
			// 						text: d.title,
			// 					}
			// 				})
			// 			} else {
			// 				deptMap[d.key] = {
			// 					text: d.title,
			// 				}
			// 			}
			// 		})
			// 		this.expandedKeys = data.map((m) => m.parentId)
			// 		this.dataList = data.map((m) => {
			// 			return {
			// 				key: m.deptId,
			// 				title: m.deptName,
			// 			}
			// 		})
			// 	}
			// })
			this.get_lis()
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				console.log(max_h, 'sssssssss')
				setTimeout(() => {
					console.log($('.ant-table-header').height(), 'aaaaaaaaaaaaa')
					this.scroll_y = max_h - $('.ant-table-header').height()
				}, 1000)
			})
		},

		methods: {
			   // 获取子分类
			getLabList(e) {
				if(e) {
					this.deviceId = true
				}else{
					this.deviceId = false
				}
				console.log(e,this.form2.deviceType, 'eeeeeeeeeeeeeeeeee==============')
				var data = ''
				this.dictList.forEach(item => {
					if(item.dictValue == e) {
					data = item
					}
				})
				getDictDataList({
					// dictLabel
					// dictType: 'lab_device'
					dictType: data.dictLabel
				}).then(res => {
					this.labList = res.rows
					console.log(res.rows,'111111111111111111111111111111111')
				})
				},
				//获取一起分类
			getDictList() {
				console.log('3333333333333333333333333333')
				getDictDataList({
					dictType: 'device_type'
				}).then(res => {
					this.dictList = res.rows
					console.log(res.rows,'2222222222222222222222222222')

				})
				},
			 changeAsset(e) {
				if(e === 53) {
					this.classify = true
					this.getDictList()
				}
				console.log(this.form2.asset_type, '22222222222222222222222')

				},
			//获取品类名称
			getName(id) {
			//获得品类名称列表
			categoryNameList({
				companyId: id,
			}).then(res => {
				if (res.code == 200) {
					this.nameList = res.data
					console.log(res, 'res==============')


				}
				console.log(this.nameList, 'nameList===========')
			})

		},

			changeCategoryName1(e) {
				console.log(e,this.form2.deviceType, 'eeeeeeeeeeeeeeeeeeeeeeee')
				this.nameList.forEach(item => {
					if(item.id == e) {
					
							this.categoryName = item.categoryName
						
						// this.form2.category_Name = item.categoryName
						// console.log(this.form2.category_Name, 'this.form2.category_Name=====================')
					}
					
				})

			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			loss() {
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				this.form = {}
				this.selectedRowKeys2.forEach((item) => {
					this.form.assertId = item
				})
				this.form.losslist = []
				this.data.forEach(item => {
					if (item.id == this.form.assertId) {
						this.form.losslist.push(item)
					}
				})
				this.profitvisible = true
			},
			//提交
			handleOkAdd: debounce(function() {
				var _this = this
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						scrapped_apply({
							cc: _this.form.cc.length ? this.info.cc.join(',') : '',
							assertId: _this.form.assertId,
							remark: _this.form.remark,
						}).then((res) => {
							console.log(res)
							if (res.code != 200) {
								this.$message.error(res.msg)
								return
							}
							this.$message.success('盘亏出库成功！')
							this.selectedRowKeys2 = []
							this.profitvisible = false
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			}, 1000, {
				'leading': true,
				'trailing': false
			}),
			onSelectChange(selectedRowKeys) {
				this.selectedRowKeys2 = selectedRowKeys
				var str = selectedRowKeys.toString()
				this.data2.forEach(item => {
					if (item.id == str) {
						this.moneY = item.purchase_price
					}
				})
			},
			getdata(data) {
				this.form.cc = data
			},
			disabledDate(current) {
				// Can not select days before today and today
				return current && current > moment().endOf('day')
			},
			changevalue() {
				this.form2.setFieldsValue({
					value: this.form2.getFieldValue('purchase_price'),
				})
			},
			editCancel() {
				this.editvisible = false
			},
			deletes(row) {
				asset_remove({
					id: row.id,
				}).then((res) => {
					this.$message.success('删除成功！')
				})
			},
			// 上传各式限制
			beforeUpload(file) {
				const tok = storage.get(ACCESS_TOKEN)
				this.headers = {
					token: tok,
				}
				this.upload.asset_sn = this.detailsrow.asset_sn
				this.upload.dept_id = this.detailsrow.dept_id
				var isType = true
				this.file_name = file.name
				const isLt2M = file.size / 1024 / 1024 < 10
				if (!isLt2M) {
					this.$message.error('上传头文件大小不能超过 10MB!')
				}
				if (file.type != 'application/pdf') {
					isType = false
					this.$message.error('只能上传pdf文件')
				}
				return isLt2M && isType
			},
			beforeUpload2(file) {
				const tok = storage.get(ACCESS_TOKEN)
				this.headers = {
					token: tok,
				}
				this.upload2.asset_sn = this.detailsrow.asset_sn
				this.upload2.dept_id = this.detailsrow.dept_id
				var isType = true
				this.file_name2 = file.name
				const isLt2M = file.size / 1024 / 1024 < 10
				if (!isLt2M) {
					this.$message.error('上传头文件大小不能超过 10MB!')
				}
				if (file.type != 'application/pdf') {
					isType = false
					this.$message.error('只能上传pdf文件')
				}
				return isLt2M && isType
			},
			//上传文件
			handleChange(info) {
				info.fileList.forEach((item, idx) => {
					if (item.type != 'application/pdf') {
						info.fileList.splice(idx, 1)
					}
				})
				if (info.file.status !== 'uploading') {
					// info.fileList.splice(info.fileList.length - 1, 1)
				}
				if (info.file.status === 'done') {
					this.$message.success('上传成功')
					this.fileList.push(info.file.response.data + ',' + info.file.name)
					// info.fileList.push(info.file)
				} else if (info.file.status === 'error') {
					this.$message.error('上传失败')
				}
			},
			//上传文件
			handleChange2(info) {
				info.fileList.forEach((item, idx) => {
					if (item.type != 'application/pdf') {
						info.fileList.splice(idx, 1)
					}
				})
				if (info.file.status !== 'uploading') {
					// info.fileList.splice(info.fileList.length - 1, 1)
				}
				if (info.file.status === 'done') {
					this.$message.success('上传成功')
					this.fileList2.push(info.file.response.data + ',' + info.file.name)
					// info.fileList.push(info.file)
				} else if (info.file.status === 'error') {
					this.$message.error('上传失败')
				}
			},
			//删除文件
			removeFile(file) {
				this.removeList.push(file.response.data)
				let data = file.response.data + ',' + file.name
				this.fileList.forEach((item, idx) => {
					if (item == data) {
						this.fileList.splice(idx, 1)
					}
				})
				console.log(this.fileList, this.defaultFileList)
			},
			//删除文件
			removeFile2(file) {
				this.removeList2.push(file.response.data)
				let data = file.response.data + ',' + file.name
				this.fileList2.forEach((item, idx) => {
					if (item == data) {
						this.fileList2.splice(idx, 1)
					}
				})
				console.log(this.fileList, this.defaultFileList)
			},
			//预览文件
			previewFile(file) {
				console.log(file)
				window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
			},
			show_img(idx, imgs) {
				var arr = []
				for(var i = 0; i < imgs.length; i++) {
					arr[i] = {
						preUrl: imgs[i]
					}
				}
				var row = {
					index: idx,
					imgs: arr,
				}
				this.$refs.preview.show(row)
			},
			result() {
				this.category_name = ''
                this.asset_type = undefined
                this.keeper = ''
                this.is_labelled = undefined
                this.has_pic = undefined
				this.name = ''
				this.asset_sn = ''
				this.state = undefined
				this.dates = []
				this.start_date = ''
				this.end_date = ''
				this.charger = ''
				this.dept_id = undefined
				this.company_id = undefined
			},
			leaderid(id) {
				this.$nextTick(() => {
					this.form2.setFieldsValue({
						keeper: undefined,
					})
				})
				dept_get(id).then((res) => {
					this.form2.setFieldsValue({
						charger: res.leader,
					})
				})
				get_users2(id, (res) => {
					this.plainOptions = res
				})
			},
			preservation2(e) {
				this.form2.validateFields((err, values) => {
					if (!err) {
						if (this.removeList.length > 0) {
							this.removeList.forEach((item) => {
								remove({
									path: item,
								}).then((res) => {
									console.log(res)
								})
							})
						}
						if (this.removeList2.length > 0) {
							this.removeList2.forEach((item) => {
								remove({
									path: item,
								}).then((res) => {
									console.log(res)
								})
							})
						}
						values['item_type'] = 1
						values['amount'] = 1
						values['create_by'] = this.$store.getters.userInfo.userName
						values['att_path'] = this.fileList.join(';')
						values['cert_path'] = this.fileList2.join(';')
						var value = values
						let resData = {}
						for (let key in value) {
							resData[key] = value[key]
							if (key == 'purchase_price' || key == 'value' || key == 'amount') {
								resData[key] = value[key] 
							}
						}
						Object.assign(resData, {
							category_name: this.categoryName
						})
						if(resData.arrive_time) {
						    resData.arrive_time = resData.arrive_time+ ' ' + '00:00:00'
						}
						if(resData.inspect_time) {
						    resData.inspect_time = resData.inspect_time+ ' ' + '00:00:00'
						}
						if(resData.purchase_time) {
						    resData.purchase_time = resData.purchase_time+ ' ' + '00:00:00'
						}
						// checkin(resData)
						assetInfo({
							deviceType: resData.deviceType,
                            dictKey: resData.dictkey,
							transType: 7,
							companyId: this.$store.state.user.info.companyId,
							// complayId: this.$router.complayId,
							amount: resData.amount,
                            arriveTime: resData.arrive_time,
                            assetSn: resData.asset_sn,
                            assetType: resData.asset_type,
                            attPath: resData.att_path,
                            categoryId: resData.category_id,
                            certPath: resData.cert_path,
                            charger: resData.charger,
                            createBy: resData.create_by,
                            dealer: resData.dealer,
                            deptId: resData.dept_id,
                            factorySn: resData.factory_sn,
                            inspectCycle: resData.inspect_cycle,
                            inspectResult: resData.inspect_result,
                            inspectTime: resData.inspect_time,
                            isInspected: resData.is_inspected,
                            // itemType: resData.item_type,
                            keeper: resData.keeper,
                            manufacturer: resData.manufacturer,
                            model: resData.model,
                            name: resData.name,
                            notes: resData.notes,
                            operator: resData.operator,
                            permit: resData.permit,
                            precisions: resData.precisions,
                            purchasePrice: resData.purchase_price.toString(),
                            purchaseTime: resData.purchase_time,
                            state: resData.state,
                            storageCond: resData.storage_cond,
                            storageLoc: resData.storage_loc,
                            unit: resData.unit,
                            value: resData.value.toString()

						}).then((res) => {
								if (res.code === 200) {
									this.$message.success('保存成功')
									this.$emit('ok')
									this.visible2 = false
									this.is_uplaod = false
									this.is_uplaod4 = false
									this.fileList = []
									this.defaultFileList = []
									this.removeList = []
									this.fileList2 = []
									this.defaultFileList2 = []
									this.removeList2 = []
									this.get_lis()
								} else {
									this.$message.success(res.msg)
								}
							})
							.catch(() => {
								this.$message.error('系统错误，请稍后再试')
							})
					}
				})
			},
			handleCancel2() {
				this.visible2 = false
				this.is_uplaod = false
				this.is_uplaod4 = false
			},
			Input() {
				this.classify = false
				this.deviceId = false
				// this.getLabList()
                // this.getDictList()
				this.getName(this.$store.state.user.info.companyId)
				this.visible2 = true
				this.form2.resetFields()
				this.is_uplaod = true
				this.is_uplaod4 = true
				this.$nextTick(() => {
					setTimeout(() => {
						this.form2.setFieldsValue({
							operator: this.$store.getters.userInfo.userName,
						})
					})
				})
			},
			view_path(path) {
				window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + path)
			},
			handlecompany(value) {
				this.deptTree2 = []
				this.deptlist = []
				this.dept_id = undefined
				this.$nextTick(() => {
					getDeptListEnable().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree2, this.company_id)
						}
					})
				})
				// this.deptlist = this.companylist[value].child_lis
			},
			handledept(value) {
				this.dept_id = value
			},
			onChange(date, dateString) {
				this.dates = date
				this.start_date = date[0]
				this.end_date = date[1]
			},
			showSizeChange(current, pageSize) {
				this.pageSize = pageSize
				this.current = current
				this.get_lis()
			},
			onShowSizeChange(current, pageSize) {
				this.selectedRowKeys = []
				this.selectedRow = []
				this.current = current
				this.get_lis()
			},
			handlestate(value) {
				this.state = value
			},
			handlestate2(value) {
				this.state2 = value
			},
			moneyOk() {
				var list = []
				this.selectedRow.forEach((item) => {
					list.push({
						id: item.id,
						value: item.value ,
					})
				})
				batch_save_value({
						data: list,
					})
					.then((res) => {
						if (res.code == 200) {
							this.changevisible = false
							this.$message.success('保存成功')
						} else {
							this.$message.success(res.msg)
						}
					})
					.catch(() => {
						this.$message.error('系统错误，请稍后再试')
					})
			},
			moneyCancel() {
				this.changevisible = false
			},
			modification() {
				this.selectedRow = []
				this.selectedRowKeys.forEach((item) => {
					this.selectedRow.push(this.data[item])
				})
				this.changevisible = true
				console.log(this.selectedRow)
			},
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			get_lis() {
				daily_list({
					pageSize: this.pageSize,
					pageNum: this.current,
					name: this.name,
					asset_sn: this.asset_sn,
					asset_type: this.asset_type,
					state: this.state,
					start_date: this.start_date,
					end_date: this.end_date,
					dept_id: this.dept_id,
					company_id: this.company_id,
					charger: this.charger,
					is_labelled: this.is_labelled,
					has_pic: this.has_pic,
					category_name: this.category_name,
					keeper: this.keeper,
				}).then((res) => {
					this.total = res.total
					res.rows.forEach(item => {
						if(item.purchase_time) {
							if (item.purchase_time.indexOf(' ') != -1) {
                       item.purchase_time = item.purchase_time.split(' ')[0]
                    }
						}
					 if(item.inspect_time) {
                         if (item.inspect_time.indexOf(' ') != -1) {
                            item.inspect_time = item.inspect_time.split(' ')[0]
                         }
					 }
					})
					this.data = res.rows
					// this.data.forEach((item) => {
					// 	item.purchase_price = item.purchase_price / 100
					// 	item.value = item.value / 100
					// 	item.amount = item.amount / 100
					// })
				})
				// assetget_list2({
				// 	page_size: this.pageSize,
				// 	page_num: this.current,
				// 	name: this.name,
				// 	asset_sn: this.asset_sn,
				// 	asset_type: this.asset_type,
				// 	state: this.state,
				// 	start_date: this.start_date,
				// 	end_date: this.end_date,
				// 	dept_id: this.dept_id,
				// 	company_id: this.company_id,
				// 	charger: this.charger,
				// 	is_labelled: this.is_labelled,
				// 	has_pic: this.has_pic,
				// }).then((res) => {
				// 	this.total = res.data.total
				// 	this.data = res.data.items
				// 	this.data.forEach((item) => {
				// 		item.purchase_price = item.purchase_price / 100
				// 		item.value = item.value / 100
				// 		item.amount = item.amount / 100
				// 	})
				// })
			},
			// get_che() {
			// 	get_checkin({
			// 		page_size: this.pageSize2,
			// 		page_num: this.current2,
			// 		name: this.name2,
			// 		asset_sn: this.asset_sn2,
			// 		state: this.state2,
			// 	}).then((res) => {
			// 		this.total2 = res.data.total
			// 		this.data2 = res.data.items
			// 	})
			// },
			add() {
				this.visible = true
			},
			Exadd() {
				this.visibleClaim = true
			},
			examine() {
				this.visibleexamine = true
			},
			handleOk(e) {
				this.loading = true
				setTimeout(() => {
					this.visible = false
					this.loading = false
				}, 2000)
			},
			handleCancel(e) {
				this.visible = false
			},
			handleOk2(e) {
				this.loading = true
				setTimeout(() => {
					this.visibleClaim = false
					this.loading = false
				}, 2000)
			},
			handleOk3(e) {
				this.loading = true
				setTimeout(() => {
					this.visibleexamine = false
					this.loading = false
				}, 2000)
			},
			query() {
				this.current = 1
				this.get_lis()
			},
			exp() {
				get_list2_xlsx({
					page_size: 99999,
					page_num: 1,
					name: this.name,
					asset_sn: this.asset_sn,
					asset_type: this.asset_type,
					state: this.state,
					start_date: this.start_date,
					end_date: this.end_date,
					dept_id: this.dept_id,
					company_id: this.company_id,
					charger: this.charger,
					is_labelled: this.is_labelled,
					has_pic: this.has_pic,
					excel: 1,
				})
			},
			ort() {
				let a = document.createElement('a')
				a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkin_records?excel=1'
				a.download = 'test'
				a.click()
				// assetget_list2({
				// 	excel: 1
				// }).then(res => {
				// 	console.log(res)
				// })
			},
			Issueexport() {
				let a = document.createElement('a')
				a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkout_records?excel=1'
				a.download = 'test'
				a.click()
				// assetget_list2({
				// 	excel: 1
				// }).then(res => {
				// 	console.log(res)
				// })
			},
			details(row) {
				// this.getName(this.$store.state.user.info.companyId)
				this.detailsvisible = true
				if(row.arrive_time) {
					 if (row.arrive_time.indexOf(' ') != -1) {
                 row.arrive_time = row.arrive_time.split(' ')[0]
                     }
				}
				
				this.detailsrow = row
				console.log(row, 'row33333333333333333================')
				var att_paths = []
				var cert_paths = []
				if (row.att_path) {
					var as = row.att_path.split(';')
					as.forEach((item) => {
						att_paths.push({
							name: item.split(',')[1],
							response: {
								data: item.split(',')[0],
							},
						})
					})
				}
				if (row.cert_path) {
					var as = row.cert_path.split(';')
					as.forEach((item) => {
						cert_paths.push({
							name: item.split(',')[1],
							response: {
								data: item.split(',')[0],
							},
						})
					})
				}
				this.detailsrow.att_paths = att_paths
				this.detailsrow.cert_paths = cert_paths
				// this.detailsrow.pic_paths = row.pic_path ? row.pic_path.split(';') : []
			},
			Warehousingdetails(row) {
				this.Warehousingvisible = true
				this.Warehousingrow = row
				console.log(row)
			},
			WarehousingOk() {
				this.Warehousingvisible = false
			},
			WarehousingCancel() {
				this.Warehousingvisible = false
			},
			detailsOk() {
				this.detailsvisible = false
			},
			detailsCancel() {
				this.detailsvisible = false
			},
			edit(row) {
				this.defaultFileList = []
				this.fileList = []
				this.removeList = []
				this.defaultFileList2 = []
				this.fileList2 = []
				this.removeList2 = []
				this.is_uplaod2 = false
				this.is_uplaod3 = false
				setTimeout(() => {
					if (row.att_path) {
						var as = row.att_path.split(';')
						as.forEach((item, index) => {
							this.fileList.push(item)
							this.defaultFileList.push({
								uid: index + 1,
								name: item.split(',')[1],
								status: 'done',
								url: item.split(',')[0],
								response: {
									data: item.split(',')[0],
								},
								type: 'application/pdf',
							})
						})
					}
					this.is_uplaod2 = true
				}, 20)
				setTimeout(() => {
					if (row.cert_path) {
						var as = row.cert_path.split(';')
						as.forEach((item, index) => {
							this.fileList2.push(item)
							this.defaultFileList2.push({
								uid: index + 1,
								name: item.split(',')[1],
								status: 'done',
								url: item.split(',')[0],
								response: {
									data: item.split(',')[0],
								},
								type: 'application/pdf',
							})
						})
					}
					this.is_uplaod3 = true
				}, 20)
				var rows = row
				let resData = {}
				for (let key in rows) {
					resData[key] = rows[key]
					resData['is_inspected'] = rows['is_inspected'] + ''
					resData['update_by'] = this.$store.getters.userInfo.userName
				}
				this.editvisible = true
				this.detailsrow = resData
				// this.detailsrow.att_paths = row.att_path ? row.att_path.split(';') : []
				this.detailsrow.pic_paths = row.pic_path ? row.pic_path.split(';') : []
			},
			// editOk() {
			// 	this.$refs.ruleForm.validate((valid) => {
			// 		if (valid) {
			// 			var detailsrow = this.detailsrow
			// 			if (this.removeList.length > 0) {
			// 				this.removeList.forEach((item) => {
			// 					remove({
			// 						path: item,
			// 					}).then((res) => {
			// 						console.log(res)
			// 					})
			// 				})
			// 			}
			// 			if (this.removeList2.length > 0) {
			// 				this.removeList2.forEach((item) => {
			// 					remove({
			// 						path: item,
			// 					}).then((res) => {
			// 						console.log(res)
			// 					})
			// 				})
			// 			}
			// 			let resData = {}
			// 			for (let key in detailsrow) {
			// 				resData[key] = detailsrow[key]
			// 				// if(key=='arrive_time'||key=='check_time'||key=='create_time'||key=='expire_time'||key=='inspect_time'||key=='purchase_time'||key=='submit_time'||key=='update_time'){
			// 				// 	resData[key]=null
			// 				// }
			// 				if (key == 'purchase_price' || key == 'value' || key == 'amount') {
			// 					resData[key] = detailsrow[key] * 100
			// 				}
			// 				delete resData['amount']
			// 				delete resData['company_name']
			// 				delete resData['dept_name']
			// 			}
			// 			resData['create_time'] = null
			// 			resData['update_time'] = null
			// 			resData['att_path'] = this.fileList.join(';')
			// 			resData['cert_path'] = this.fileList2.join(';')
			// 			console.log(resData)
			// 			update(resData)
			// 				.then((res) => {
			// 					if (res.code == 200) {
			// 						this.editvisible = false
			// 						this.$message.success('编辑成功')
			// 						this.removeList = []
			// 						this.removeList2 = []
			// 						this.get_lis()
			// 					} else {
			// 						this.$message.success(res.msg)
			// 					}
			// 				})
			// 				.catch(() => {
			// 					this.$message.error('系统错误，请稍后再试')
			// 				})
			// 		} else {
			// 			return false
			// 		}
			// 	})
			// },
		},
	}
</script>
<style scoped>
	.dialog {
		display: flex;
		justify-content: space-between;
	}

	.flex {
		display: flex;
	}

	.center {
		text-align: center;
		width: 832px;
	}

	.dialog .dialog_item {
		margin-bottom: 5px;
		width: 220px;
		display: flex;
		justify-content: space-between;
	}

	.Exhi {
		display: inline-block;
		border: 1px solid black;
		width: 100px;
		text-align: left;
		color: steelblue;
	}

	.form_item {
		float: left;
		width: 50%;
		min-height: 50px;
		margin-bottom: 10px;
	}

	.editable-cell {
		position: relative;
	}

	.editable-cell-input-wrapper,
	.editable-cell-text-wrapper {
		padding-right: 24px;
	}

	.editable-cell-text-wrapper {
		padding: 5px 24px 5px 5px;
	}

	.editable-cell-icon,
	.editable-cell-icon-check {
		position: absolute;
		right: 0;
		width: 20px;
		cursor: pointer;
	}

	.editable-cell-icon {
		line-height: 18px;
		display: none;
	}

	.editable-cell-icon-check {
		line-height: 28px;
	}

	.editable-cell:hover .editable-cell-icon {
		display: inline-block;
	}

	.editable-cell-icon:hover,
	.editable-cell-icon-check:hover {
		color: #108ee9;
	}

	.editable-add-btn {
		margin-bottom: 8px;
	}

	.border_a_input {
		border: 1px solid #ddd;
	}

	.view_path {
		width: 100%;
		float: left;
		cursor: pointer;
	}
</style>
